<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[1]" v-text="node.label.split('###')[0]"></span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 290px);">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>报告类型：</label>
                        <el-select v-model="search_Obj.f_report_type" placeholder="请选择" @change="doSearch">
                            <el-option label="监测报告" value="12"></el-option>
                            <el-option label="抽检报告" value="14"></el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>处置情况：</label>
                        <el-select v-model="search_Obj.deal_type" placeholder="请选择" @change="doSearch">
                            <el-option label="未处置" value="0"></el-option>
                            <el-option label="已处置" value="1"></el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>孔号：</label>
                        <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>段号：</label>
                        <el-input v-model="search_Obj.f_segment_no" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="unit_code" label="单元编号" sortable="custom" width="200"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom" width="220"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="work_type" label="作业方式" sortable="custom" width="120"></el-table-column>
                        <el-table-column label="处置结果" width="120" v-if="search_Obj.deal_type =='1'">
                            <template slot-scope="scope">
                                <span v-if="search_Obj.f_report_type=='12' && scope.row.deal_result_check==1">数据正常</span>
                                <span v-if="search_Obj.f_report_type=='12' && scope.row.deal_result_check==2">数据异常</span>
                                <span v-if="search_Obj.f_report_type=='12' && scope.row.deal_result_check==3">数据丢失</span>
                                <span v-if="search_Obj.f_report_type=='14' && scope.row.deal_result_diff==1">数据正常</span>
                                <span v-if="search_Obj.f_report_type=='14' && scope.row.deal_result_diff==2">数据异常</span>
                                <span v-if="search_Obj.f_report_type=='14' && scope.row.deal_result_diff==3">数据丢失</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button @click="dealReport(scope.row.id, 12)" size="mini" plain type="primary" v-if="scope.row.has_check==1 && search_Obj.f_report_type=='12'">
                                    处置监测对比
                                </el-button>
                                <el-button @click="dealReport(scope.row.id, 14)" size="mini" plain type="primary" v-if="scope.row.has_diff==1 && search_Obj.f_report_type=='14'">
                                    处置差异对比
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
            </div>
        </el-card>
        <Info
            :report_type="report_type"
            :report_id="report_id"
            title="处置对比报告"
            :isshow="infoshow"
            @on-close="closeInfoDialog"
            @on-save-ok="saveDealOk">
        </Info>
    </div>
</template>

<script>
import listutil from "@/libs/listutil"
import Info from "./nodealinfo.vue"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'

export default {
    name: 'workreportNodealCheckHole',
    mixins: [listutil],
    components: {Info},
    data() {
        return {
            m_name: '未处理-作业报告',
            menu_id: 5951,
            list_url: "/api/admin/workreport/nodealReportList",
            search_Obj: {
                f_report_type: '12',
                deal_type: '0',
                f_unit_code: '',
                f_hole_code: '',
                f_segment_no: '',
            },
            del_Obj:{
                url:'/api/admin/workreport1/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['work_type_int'],
            report_id: 0,
            report_type: 0,
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(2).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.current = 1
            this.getListData()
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        dealReport(id, type){
            this.report_id = id
            this.report_type = type
            this.infoshow = true
        },
        saveDealOk(){
            this.getListData()
            this.infoshow = false
        }
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
</style>